<template>
  <Breadcrumb
    v-if="!isMobile"
    :category-name="categoryName"
  />
  <PageContainer
    class="text-search"
    as-child
  >
    <PCBestdealerPublicity
      v-if="!isMobile"
      class="text-search__publicity"
    />
    <div class="text-search__wrapper">
      <AiDeepSearch v-if="isShowAiDeepSearch" />
      <H5TagFilter v-if="isMobile" />
      <TagFilter v-else />
      <Product
        class="text-search__content"
        :loading="loading"
        :product-list="list"
        @load="onLoad"
        @item-click="onItemClick"
      />
    </div>
  </PageContainer>
</template>

<script setup>
import TagFilter from './components/TagFilter/index.vue'
import H5TagFilter from './components/H5TagFilter/index.vue'
import Breadcrumb from './components/Breadcrumb/index.vue'
import { AiDeepSearch } from './components/AiDeepSearch'
import { useProductList } from './hooks/useProductList'
import { Product } from '@/components/NewProduct'
import { buriedPointUtil, gaAnalytics, openURLWithChannelQuery } from '@/utils/utils'
import { PageContainer } from '@/components/PageLayout'
import PCBestdealerPublicity from '@/components/BestdealerPublicity/PCBestdealerPublicity.vue'
import { isMobile } from '@/utils/constants'

const route = useRoute()

const categoryName = computed(() => route.query.categoryName)
/**
 * 文搜页两种情况不触发 Ai DeepSearch
 * 1. 从 DeepSearch 结果点击跳转到的 文搜页
 * 2. 类目搜索
 */
const isShowAiDeepSearch = computed(() => !route.query.isAISearched && categoryName.value == null)

const { loading, list, onLoad } = useProductList()

const onItemClick = (item) => {
  if (isMobile) {
    buriedPointUtil({ eventId: 'MPSC205', spuId: item.offerId })
    gaAnalytics('mp_search_page_click', 'mp_search_page_click', { spuId: item.offerId })
  } else {
    gaAnalytics('p_search_page_click', 'p_search_page_click', { spuId: item.offerId })
    buriedPointUtil({ eventId: 'PSC205', spuId: item.offerId })
  }
  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}&adding=${btoa(item.addingCount)}`)
}
</script>

<style lang="less" scoped>
.text-search {
  display: flex;
  gap: 24px;

  &__publicity {
    padding: 24px 0;
    flex-shrink: 0;
  }

  &__wrapper {
    width: 100%;
  }

  &__content {
    padding: 16px 0;

    @media (min-width: 1024px) {
      padding: 24px 0;
    }
  }
}
</style>
